var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStyleGuidesDelete = function SvgStyleGuidesDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M65 15H35c-5.523 0-10 4.477-10 10v70c0 5.523 4.477 10 10 10h50c5.523 0 10-4.477 10-10V45L65 15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#68ADFF",
    d: "M65 45V15l30 30H65Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40 65a5 5 0 0 1 5-5h30a5 5 0 0 1 0 10H45a5 5 0 0 1-5-5ZM40 85a5 5 0 0 1 5-5h30a5 5 0 0 1 0 10H45a5 5 0 0 1-5-5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F65050",
    fillRule: "evenodd",
    d: "M77.25 97c0-7.042 5.708-12.75 12.75-12.75s12.75 5.708 12.75 12.75-5.708 12.75-12.75 12.75S77.25 104.042 77.25 97Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M84.748 91.748a1.417 1.417 0 0 1 2.004 0l8.5 8.5a1.417 1.417 0 0 1-2.004 2.004l-8.5-8.5a1.417 1.417 0 0 1 0-2.004Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M95.252 91.748a1.417 1.417 0 0 0-2.004 0l-8.5 8.5a1.417 1.417 0 0 0 2.004 2.004l8.5-8.5a1.417 1.417 0 0 0 0-2.004Z",
    clipRule: "evenodd"
  })));
};
export default SvgStyleGuidesDelete;